// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* BREAKPOINTS */
.Menu_menuWrapper__A3qzo {
  grid-area: menu;
}

.Menu_menu__JC\\+xS {
  --upperMenuHeight: 60px;
  --lowerMenuHeight: 60px;
  grid-area: menu;
  display: grid;
  align-items: center;
  grid-template: "navigation search notifications user" var(--upperMenuHeight)/auto 1fr auto auto;
}
.Menu_menu__JC\\+xS.Menu_collapsed__9cyRZ {
  display: none;
}
.Menu_menu__JC\\+xS a {
  text-decoration: none;
}
@media (min-width: 768px) {
  .Menu_menu__JC\\+xS {
    grid-template: "social search notifications user" var(--upperMenuHeight) "navigation navigation navigation navigation" var(--lowerMenuHeight)/auto 1fr auto auto;
  }
}`, "",{"version":3,"sources":["webpack://./src/core/_breakpoints.scss","webpack://./src/views/Template/components/Menu/Menu.module.scss"],"names":[],"mappings":"AAAA,gBAAA;ACCA;EACE,eAAA;AACF;;AACA;EAOE,uBAAA;EACA,uBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,+FACE;AALJ;AAPE;EACE,aAAA;AASJ;AAPE;EACE,qBAAA;AASJ;ADXI;ECHJ;IAgBI,gKACE;EACJ;AACF","sourcesContent":["/* BREAKPOINTS */\n@mixin breakpoint-up($point) {\n  @if $point == sm {\n    @media (min-width: 576px) {\n      @content;\n    }\n  } @else if $point == md {\n    @media (min-width: 768px) {\n      @content;\n    }\n  } @else if $point == lg {\n    @media (min-width: 992px) {\n      @content;\n    }\n  } @else if $point == xl {\n    @media (min-width: 1200px) {\n      @content;\n    }\n  }\n}\n\n@mixin breakpoint-down($point) {\n  @if $point == xs {\n    @media (max-width: 575.98px) {\n      @content;\n    }\n  } @else if $point == sm {\n    @media (max-width: 767.98px) {\n      @content;\n    }\n  } @else if $point == md {\n    @media (max-width: 991.98px) {\n      @content;\n    }\n  } @else if $point == lg {\n    @media (max-width: 1199.98px) {\n      @content;\n    }\n  }\n}\n","@import \"core/_breakpoints.scss\";\n.menuWrapper {\n  grid-area: menu;\n}\n.menu {\n  &.collapsed {\n    display: none;\n  }\n  a {\n    text-decoration: none;\n  }\n  --upperMenuHeight: 60px;\n  --lowerMenuHeight: 60px;\n  grid-area: menu;\n  display: grid;\n  align-items: center;\n  grid-template:\n    \"navigation search notifications user\" var(--upperMenuHeight) /\n    auto 1fr auto auto;\n  @include breakpoint-up(md) {\n    grid-template:\n      \"social search notifications user\" var(--upperMenuHeight)\n      \"navigation navigation navigation navigation\" var(--lowerMenuHeight) /\n      auto 1fr auto auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menuWrapper": `Menu_menuWrapper__A3qzo`,
	"menu": `Menu_menu__JC+xS`,
	"collapsed": `Menu_collapsed__9cyRZ`
};
export default ___CSS_LOADER_EXPORT___;
